const URL = process.env.NODE_ENV === 'production' ? 'https://tkycapi.ddtmx.com/' : 'http://localhost:21021/';
export default URL;